<template>
  <span class="picture">
    <img v-if="picture" :src="picture" alt="" class="w-full">
    <component v-else :is="$props.default" class="bg-gray-100 h-full-20 w-full text-gray-300" />
  </span>
</template>

<script lang="ts">
import { type RenderFunction, onUnmounted } from 'vue'
import { UserIcon } from '@heroicons/vue/24/solid'

export default defineComponent({
  name: "t-picture",
  props: {
    src: [String, File],
    default: { type: Function as PropType<RenderFunction>, default: UserIcon },
    size: { type: Number, default: () => 3.5 }
  },
  setup(props) {

    const { $api } = useNuxtApp()

    const picture = ref<string | null>(null)

    watch(() => props.src, (val) => {
      if (val && typeof val === 'string') {
        $api.http.fetch(val)
          .then(async r => { picture.value = URL.createObjectURL(await r.blob()) })
          .catch(e => console.warn(e))
      }
    }, { immediate: true })

    onUnmounted(() => {
      if (picture.value) URL.revokeObjectURL(picture.value)
    })

    return { picture }
  }
})
</script>


<style lang="postcss">
.picture {
  @apply inline-block rounded-full overflow-hidden border-4 border-transparent;
  height: calc(v-bind(size) * 1rem);
  width: calc(v-bind(size) * 1rem);

}
</style>